import { CampaignStatus } from '../models';
import { SubscribeQuery } from '@/queries';

const getAll = (
  retailerId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  className: 'Campaign',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
    status: {
      $ne: CampaignStatus.Cancelled,
    },
  },
  include: 'createdBy',
  order: `${orderDesc ? '-' : ''}${orderBy}`,
  count: 1,
  limit: pageSize,
  skip: pageSize * (page - 1),
});

const getAllDraft = (
  retailerId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, page, pageSize, orderBy, orderDesc).where,
    status: CampaignStatus.Draft,
  },
});

const getAllPaused = (
  retailerId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, page, pageSize, orderBy, orderDesc).where,
    status: CampaignStatus.Paused,
  },
});

const getAllFinished = (
  retailerId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, page, pageSize, orderBy, orderDesc).where,
    status: CampaignStatus.Finished,
  },
});

const getAllRunning = (
  retailerId: string, page: number, pageSize: number, orderBy: string, orderDesc: boolean,
): SubscribeQuery => ({
  ...getAll(retailerId, page, pageSize, orderBy, orderDesc),
  where: {
    ...getAll(retailerId, page, pageSize, orderBy, orderDesc).where,
    $or: [
      {
        status: {
          $eq: CampaignStatus.Sending,
        },
      }, {
        $and: [
          {
            status: {
              $eq: CampaignStatus.Schedulled,
            },
          },
          {
            scheduledTo: {
              $lt: {
                __type: 'Date',
                iso: new Date().toISOString(),
              },
            },
          },
        ],
      },
    ],
  },
});

const getById = (id: string): SubscribeQuery => ({
  className: 'Campaign',
  where: {
    objectId: id,
  },
});

const CampaignQueries = {
  getAll,
  getAllDraft,
  getAllPaused,
  getAllFinished,
  getAllRunning,
  getById,
};

export default CampaignQueries;
